// src/api/endpoints/fullServiceInvoice.js
import { rootApi } from '../rootApi';

export const fullServiceInvoiceApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getFullServiceInvoices: builder.query({
            query: (params) => {
                return {
                    url: `api/fullserviceinvoices/getfullserviceinvoices`,
                    method: 'GET',
                    params: {
                        PageNumber: params.pageNumber,
                        PageSize: params.pageSize,
                        ChassisNo: params.chassisNo,
                        DealerId: params.dealerId,
                        // CustomerId: params.customerId,
                        ContractStartDate: params.contractStartDate,
                        ContractEndDate: params.contractEndDate
                    }
                };
            },
            providesTags: ['FullServiceInvoice']
        }),

        getFullServiceInvoiceById: builder.query({
            query: (id) => ({
                url: `api/fullserviceinvoices/getfullserviceinvoicesbyid?id=${id}`,
                method: 'GET'
            }),
            providesTags: ['FullServiceInvoice']
        }),

        createFullServiceInvoice: builder.mutation({
            query: (data) => ({
                url: 'api/fullserviceinvoices/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['FullServiceInvoice']
        }),

        updateFullServiceInvoice: builder.mutation({
            query: (data) => ({
                url: 'api/fullserviceinvoices/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['FullServiceInvoice']
        }),

        deleteFullServiceInvoice: builder.mutation({
            query: (id) => ({
                url: 'api/fullserviceinvoices/delete',
                method: 'POST',
                body: { id }
            }),
            invalidatesTags: ['FullServiceInvoice']
        }),
        sendFullServiceToSap: builder.mutation({
            query: (fullServiceId) => ({
                url: 'api/fullserviceinvoices/SendToSap',
                method: 'POST',
                body: { fullServiceId }
            }),
            invalidatesTags: ['FullServiceInvoice']
        }),
        getCurrencyByDealerId: builder.query({
            query: (dealerId) => ({
                url: `api/fullserviceinvoices/GetCurrencyByDealerId`,
                method: 'GET',
                params: { DealerId: dealerId }
            })
        })
    })
});

export const { useGetFullServiceInvoicesQuery, useGetFullServiceInvoiceByIdQuery, useCreateFullServiceInvoiceMutation, useUpdateFullServiceInvoiceMutation, useDeleteFullServiceInvoiceMutation, useSendFullServiceToSapMutation,useLazyGetCurrencyByDealerIdQuery } =
    fullServiceInvoiceApi;
